import { render, staticRenderFns } from "./DrawingRequestShowChat.vue?vue&type=template&id=4527dfde&scoped=true&"
import script from "./DrawingRequestShowChat.vue?vue&type=script&lang=js&"
export * from "./DrawingRequestShowChat.vue?vue&type=script&lang=js&"
import style0 from "./DrawingRequestShowChat.vue?vue&type=style&index=0&id=4527dfde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4527dfde",
  null
  
)

export default component.exports